/* global require */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Header } from 'native-base';
import { Col, Grid } from 'react-native-easy-grid';
import { Image, Dimensions, TouchableOpacity } from 'react-native';
import { styles, C } from '../../constants';
import { openURL } from '../../_helpers';

let deviceWidth = Dimensions.get('window').width;

import {
  sendLogout
} from '../../actions';

class AppHeader extends Component {

  handlerExit = () => {
    this.props.dispatch(sendLogout());
  }

  handlerPressLogo = () => {
    openURL("https://rzd-medicine.ru");
  }

  render() {
    return (
      <Header style={styles.appHeader}>
        <Grid style={styles.appHeaderGrid}>
          <Col style={styles.appHeaderCol_1}>
            <TouchableOpacity onPress={() => this.handlerPressLogo()} style={{display:"block", height: "100%", width: "100%"}}>
              <Image
                resizeMode='contain'
                source={require('../../../assets/img/rzd_logo.png')}
                style={{
                  minWidth: 158,
                  height: 67,
                  width: "100%"
                }} />
            </TouchableOpacity >
          </Col>
          {deviceWidth > C.MIN_WIDTH ? <Col style={styles.appHeaderCol_2}><Image
            resizeMode='contain'
            source={require('../../../assets/img/covid_logo.png')}
            style={{
              minWidth: 300,
              marginLeft: 10,
              marginRight: 10,
              height: 32,
              width: "100%"
            }} /></Col> : null}
          <Col style={styles.appHeaderCol_3}><Image
            resizeMode='contain'
            source={require('../../../assets/img/corona_logo_blue_red.png')}
            style={{
              minWidth: 108,
              height: 31,
              width: "100%"
            }}
          /></Col>
        </Grid></Header>
    );
  }
}


AppHeader.propTypes = {
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = () => ({
});

export default connect(mapStateToProps)(AppHeader);